// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__XoZL-","footer":"Form_footer__1HlSY"};